// Retain an operation ID through failed/lost responses. A changed payload is a new intent.
// Nothing is automatically retried after reload or account handoff.
export function gearOperation() {
  let fingerprint = '', id = ''
  return (payload: unknown) => {
    const next = JSON.stringify(payload)
    if (next !== fingerprint || !id) { fingerprint = next; id = crypto.randomUUID() }
    return id
  }
}

export function localReturnPath(value: unknown, fallback = '/trips'): string {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u001f]/.test(value)) return fallback
  const url = new URL(value, window.location.origin)
  return url.origin === window.location.origin ? `${url.pathname}${url.search}` : fallback
}
